"use client";

import { useMutation } from "@ui/hooks/useMutation";
import { getCaptchaToken } from "@/app/_providers/hcaptcha/core";
import { toast } from "@/app/_providers/toast";
import { env } from "@/env";
import { useTranslations } from "next-intl";
import { getErrorMessageFromUnknownError } from "@utilities/errors";

export function useRequestCallMutation() {
  const t = useTranslations("ClientKeys.hero_agent");

  return useMutation({
    mutationFn: async (variables: { phone_number: string }) => {
      const hcaptchaToken = await getCaptchaToken({ behaviourType: "agent_request_call" });

      const response = await fetch(`${env.NEXT_PUBLIC_XI_SERVER_URL}/v1/agents/request-call/anonymous`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone_number: variables.phone_number,
          hcaptcha_token: hcaptchaToken,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = getErrorMessageFromUnknownError(errorData, {
          defaultMessage: t("views.request_call.errors.default"),
        });
        throw new Error(errorMessage);
      }

      return (await response.json()) as Promise<{ message: string; retry_after_seconds?: number | null }>;
    },
    onError: error => {
      toast.error(error?.message || t("views.request_call.errors.default"));
    },
  });
}
